import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import UpdatePasswordForm from '../views/firstLoginSetting/UpdatePasswordForm'
import FirstLoginForm from '../views/firstLoginSetting/FirstLoginForm'
import ChangePassword from '../views/ChangePassword'
import LoginSettingComplete from '../views/firstLoginSetting/LoginSettingComplete'
import Main from '../views/Main'
import FindAccount from '../views/FindAccount'

import RedirectConcierge from '../views/RedirectConcierge'
import RedirectTna from '../views/RedirectTna'
import RedirectGew from '../views/RedirectGew'

import IntroduceBooking from '../views/introduce/etnersBooking'
import IntroduceAssetManagement from '../views/introduce/etnersAssetManagement'
import IntroduceAttendance from '../views/introduce/etnersAttendance'
import IntroduceConcierge from '../views/introduce/etnersConcierge'
import IntroduceBidding from '../views/introduce/etnersBidding'
import IntroduceChongmu from '../views/introduce/etnersChongmu'
import IntroduceDms from '../views/introduce/etnersDms'
import IntroduceHousing from '../views/introduce/etnersHousing'
import IntroduceMall from '../views/introduce/etnersMall'
import IntroduceMoving from '../views/introduce/etnersMoving'
import IntroducePayroll from '../views/introduce/etnersPayroll'
import IntroduceShop from '../views/introduce/etnersShop'
import JwtService from '../common/jwt.service'
import Notice from '../views/notice/NoticeList'
import NoticeDetail from '../views/notice/NoticeDetail'
import NoticeForm from '../views/notice/NoticeForm'
import { store } from '../store/index'

import AdminMain from '../views/admin/main/AdminMain'
import AdminSolution from '../views/admin/solution/AdminSolution'
import AdminSolutionDetail from '../views/admin/solution/AdminSolutionDetail'
import AdminSolutionSave from '../views/admin/solution/AdminSolutionSave'
import AdminCompany from '../views/admin/company/AdminCompany'
import AdminCompanyDetail from '../views/admin/company/AdminCompanyDetail'
import EtnersCommonUtil from '@/common/etners.common.util'
import ApiUtil from "../api/api.util";
import ApiConfig from "../api/api.config";
import AdminCompanySave from '../views/admin/company/AdminCompanySave'
import AdminUser from '../views/admin/user/AdminUser'
import AdminUserDetail from '../views/admin/user/AdminUserDetail'
import AdminUserSave from '../views/admin/user/AdminUserSave'
import AdminMenuDetail from "../views/admin/menu/AdminMenuDetail";
import AdminMenu from "../views/admin/menu/AdminMenu";
import AdminMenuSave from "../views/admin/menu/AdminMenuSave";

import AdminDept from '../views/admin/organization/AdminDept'
import AdminDeptUser from '../views/admin/organization/AdminDeptUser'


import AdminCompanyCode from '../views/admin/code/AdminCompanyCode'
import AdminSolutionCode from '../views/admin/code/AdminSolutionCode'

import AdminAuth from '../views/admin/auth/AdminAuth'
import AdminAuthDetail from '../views/admin/auth/AdminAuthDetail'
import AdminAuthSave from '../views/admin/auth/AdminAuthSave'

import DailyAttendanceChart from '../views/charts/tna/DailyAttendanceChart'
import MainChart from '../views/charts/gew/MainChart'

Vue.use(VueRouter)

const isFirstLogin = function () {
  console.log(`isFirstLogin !!`)
  // console.log(`sessionStorage.getItem('isFirstLogin') : ${sessionStorage.getItem('isFirstLogin')}`)

  let firstLoginFl

  if (sessionStorage.getItem('isFirstLogin') === undefined || sessionStorage.getItem('isFirstLogin') === null) {
    firstLoginFl = 'Y'
  } else {
    firstLoginFl = sessionStorage.getItem('isFirstLogin')
  }

  return firstLoginFl
}

const isPwdDateOver = function () {

  let isPwdDateOverFl

  if (sessionStorage.getItem('isPwdDateOver') === undefined ||
    sessionStorage.getItem('isPwdDateOver') === null) {
    isPwdDateOverFl = 'N'
  } else {
    isPwdDateOverFl = sessionStorage.getItem('isPwdDateOver')
  }

  return isPwdDateOverFl
}

// 로그인 권한이 있는지 가드 체크
const requireAuth = () => (from, to, next) => {

  let firstLoginFl = isFirstLogin()

  let isAuthenticated = store.state.loginStore.isAuthenticated
  const directArr  = document.location.search.split('?')

  if (isAuthenticated && JwtService.getToken() !== undefined && firstLoginFl === 'N') {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))

    if(directArr.length > 1){
      location.href = `${directArr[1]}?loginUserToken=${sessionStorage.lutk}`
    }else if(sessionStorage.directUrl !== undefined){
      location.href = `${sessionStorage.directUrl}?loginUserToken=${sessionStorage.lutk}`
    }

    const defaultRedirectSolCd = userInfo.defaultRedirectSolCd

    switch (defaultRedirectSolCd) {
      case '0000' :
        // 플랫폼 메인으로 가게 한다.
        return next()
      case '1000':
        // 컨시어지로 이동
        return next('/redirectConcierge')
      case '1001':
        // 근태관리솔루션으로 이동
        return next('/redirectTna')
      case '1007':
        // 사무비품으로 이동
        return next('/redirectGew')
      default:
        // 플랫폼 메인으로 가게 한다.
        return next()
    }
  }
  if(directArr.length > 1) {
    kendo.alert('로그인이 필요합니다.')
    sessionStorage.directUrl = directArr[1]
    location.href = './login'
  }
  next('/login')
}

// 최초 로그인인지 네비게이션 가드 체크
const requireFirstAgreement = () => (from, to, next) => {
  let firstLoginFl = isFirstLogin()
  let PwdDateOverFl = isPwdDateOver()

  if (firstLoginFl === 'Y') {
    return next()
  } else {
    store.dispatch('FETCH_USER').then(() => {
      if(PwdDateOverFl === 'Y'){
        next('/changePassword')
      }else {
        next('/')
      }
    })
  }
}

// 2021.11.24 admin 별도 인스턴스 생성으로 인해 경영지원플랫폼 메인에서 제거
/*const requireAdmin = () => (from, to, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))

  if (userInfo.solCd.indexOf('0001') === -1) {
    kendo.alert('권한이 존재하지 않습니다.')
    next('/')
  } else {
      store.dispatch('initSearchDataForCodeRequest')
    if(sessionStorage.getItem('adminUserInfo')=== undefined || sessionStorage.getItem('adminUserInfo') === null) {
      ApiUtil.post(`${ApiConfig.singleDomain}/v1/ebmp/solution/user/firstAccessInfo.json`, {
        loginUserToken: sessionStorage.lutk,
        currentSolcd: '0001'
      })
        .then(response => {

          const result = response.data
          if (result.resultStatus.messageCode === '2000') {
            sessionStorage.setItem('adminUserInfo', JSON.stringify(result.resultData))

          } else {
            kendo.alert(result.resultStatus.messageText)
          }

        })
    }
       EtnersCommonUtil.cleanCacheRefreshSessionData()  //메뉴 진입전 세션을 clean 하고 다시 데이터를 받아온다.
      setTimeout(function () {

        next()

      }, 1000)

  }
}*/

export const router = new VueRouter({
  routes: [
    /*******************************************************
     * 다른 솔루션으로 리다이렉트하기 위한 매핑 URL 설정 시작
     *******************************************************/
    {
      path: '/redirectConcierge',
      name: 'RedirectConcierge',
      component: RedirectConcierge,
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/redirectTna',
      name: 'RedirectTna',
      component: RedirectTna,
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/redirectGew',
      name: 'RedirectGew',
      component: RedirectGew,
      meta: {
        layout: 'LoginLayout'
      }
    },
    /*******************************************************
     * 다른 솔루션으로 리다이렉트하기 위한 매핑 URL 설정 종료
     *******************************************************/

    {
      path: '/',
      name: 'Main',
      component: Main,
      beforeEnter: requireAuth(),
      meta: {
        layout: 'MainLayout'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/firstLoginForm',
      name: 'FirstLoginForm',
      component: FirstLoginForm,
      beforeEnter: requireFirstAgreement(),
      meta: {
        layout: 'NoInfoHeaderLayout'
      }
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        layout: 'NoInfoHeaderLayout',
      },
    },
    {
      path: '/findAccount',
      name: 'FindAccount',
      component: FindAccount,
      meta: {
        layout: 'LoginLayout'
      },
      props: true
    },
    {
      path: '/loginSettingComplete',
      name: 'LoginSettingComplete',
      component: LoginSettingComplete,
      meta: {
        layout: 'NoInfoHeaderLayout'
      }

    },
    {
      path: '/updatePasswordForm',
      name: 'UpdatePasswordForm',
      component: UpdatePasswordForm,
      meta: {
        layout: 'NoInfoHeaderLayout'
      }
    },
    {
      path: '/notice',
      name: 'Notice',
      component: Notice,
      meta: {
        layout: 'MainLayout'
      },
      props: true
    },
    {

      path: '/introduceConcierge',
      name: 'Introduce1000',
      component: IntroduceConcierge,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceAttendance ',
      name: 'Introduce1001',
      component: IntroduceAttendance,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceAssetManagement ',
      name: 'Introduce1007',
      component: IntroduceAssetManagement,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceBooking',
      name: 'Introduce1008',
      component: IntroduceBooking,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceBidding',
      name: 'IntroduceBidding',
      component: IntroduceBidding,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceDms',
      name: 'IntroduceDms',
      component: IntroduceDms,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceChongmu',
      name: 'IntroduceChongmu',
      component: IntroduceChongmu,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceHousing',
      name: 'IntroduceHousing',
      component: IntroduceHousing,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceMall',
      name: 'IntroduceMall',
      component: IntroduceMall,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceMoving',
      name: 'IntroduceMoving',
      component: IntroduceMoving,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introducePayroll',
      name: 'IntroducePayroll',
      component: IntroducePayroll,
      meta: {
        layout: 'MainLayout'
      }
    },
    {

      path: '/introduceShop',
      name: 'IntroduceShop',
      component: IntroduceShop,
      meta: {
        layout: 'MainLayout'
      }
    },
    {
      path: '/noticeDetail',
      name: 'NoticeDetail',
      component: NoticeDetail,
      meta: {
        layout: 'MainLayout'
      },
      props: true
    },
    {
      path: '/noticeForm',
      name: 'NoticeForm',
      component: NoticeForm,
      meta: {
        layout: 'MainLayout'
      }
    },

    { // 공지사항 목록(new)
      path: '/commonBoard/noticeList/',
      name: 'NoticeListNew',
      component: () => import('@/views/commonBoard/NoticeList'),
      meta: {
        layout: 'MainLayout'
      }
    },
    { // 공지사항 상세(new)
      path: '/commonBoard/noticeDetail/',
      name: 'NoticeDetailNew',
      component: () => import('@/views/commonBoard/NoticeDetail'),
      meta: {
        layout: 'MainLayout'
      }
    },
    { // 공지사항 신규(new)
      path: '/commonBoard/editNotice/',
      name: 'EditNoticeNew',
      component: () => import('@/views/commonBoard/EditNotice'),
      meta: {
        layout: 'MainLayout'
      }
    },
    { // 공지사항 수정(new)
      path: '/commonBoard/writeNotice/',
      name: 'WriteNoticeNew',
      component: () => import('@/views/commonBoard/WriteNotice'),
      meta: {
        layout: 'MainLayout'
      }
    },


    /********************************************************
     * 관리자
     ********************************************************/
    /*{
      path: '/admin',
      redirect: '/admin/solution'
    },
    {
      path: '/admin/main',
      name: 'AdminMain',
      component: AdminMain,
      beforeEnter: requireAdmin(),
      meta: {
        layout: 'AdminLayout'
      }
    },
    {
      path     : '/admin/solution',
      name     : 'AdminSolution',
      component: AdminSolution,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/solution/detail/:solCd/:wmGbn',
      name: 'AdminSolutionDetail',
      component: AdminSolutionDetail,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/solution/save',
      name: 'AdminSolutionSave',
      component: AdminSolutionSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/solution/save/:solCd/:wmGbn',
      name: 'AdminSolutionSaveEdit',
      component: AdminSolutionSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/company',
      name: 'AdminCompany',
      component: AdminCompany,
      beforeEnter: requireAdmin(),
      meta: {
        layout: 'AdminLayout'
      }
    },
    {
      path: '/admin/company/detail/:cmpyCd',
      name: 'AdminCompanyDetail',
      component: AdminCompanyDetail,
      beforeEnter: requireAdmin(),
      meta: {
        layout: 'AdminLayout'
      }
    },
    {
      path: '/admin/company/save',
      name: 'AdminCompanyInsert',
      component: AdminCompanySave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/company/save/:cmpyCd',
      name: 'AdminCompanyUpdate',
      component: AdminCompanySave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path     : '/admin/user',
      name     : 'AdminUser',
      component: AdminUser,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/user/detail/:cmpyCd/:sabun',
      name: 'AdminUserDetail',
      component: AdminUserDetail,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/user/save/',
      name: 'AdminUserInsert',
      component: AdminUserSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/user/save/:cmpyCd/:sabun', //사번이 없으면 신규, 사번이 존재하면 수정
      name: 'AdminUserUpdate',
      component: AdminUserSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path     : '/admin/menu',
      name     : 'AdminMenu',
      component: AdminMenu,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/menu/detail/:solCd/:wmGbn/:menuId',
      name: 'AdminMenuDetail',
      component: AdminMenuDetail,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/menu/save',
      name: 'AdminMenuSave',
      component: AdminMenuSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/menu/save/:solCd/:wmGbn/:menuId',
      name: 'AdminMenuUpsert',
      component: AdminMenuSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/organization/dept',
      name: 'AdminDept',
      component: AdminDept,
      beforeEnter: requireAdmin(),
      meta: {
        layout: 'AdminLayout'
      }
    },
    {
      path: '/admin/organization/deptUser',
      name: 'AdminDeptUser',
      component: AdminDeptUser,
      beforeEnter: requireAdmin(),
      meta: {
        layout: 'AdminLayout'
      }
    },
    {
      path     : '/admin/code/company',
      name     : 'AdminCodeCompany',
      component: AdminCompanyCode,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path     : '/admin/code/solution',
      name     : 'AdminSolutionCode',
      component: AdminSolutionCode,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path     : '/admin/auth',
      name     : 'AdminAuth',
      component: AdminAuth,
      beforeEnter: requireAdmin(),
      meta     : {
    	layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/auth/detail/:solCd/:cmpyCd/:authCd',
      name: 'AdminAuthDetail',
      component: AdminAuthDetail,
      beforeEnter: requireAdmin(),
      meta: {
    	   layout: 'AdminLayout'
      }
    },
    {
      path: '/admin/auth/save',
      name: 'AdminAuthInsert',
      component: AdminAuthSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },
    {
      path: '/admin/auth/save/:cmpyCd/:solCd/:authCd',
      name: 'AdminAuthUpdate',
      component: AdminAuthSave,
      beforeEnter: requireAdmin(),
      meta     : {
        layout: 'AdminLayout',
      },
    },*/

    /********************************************************
     * 대시보드 차트
     ********************************************************/
    {
      path: '/admin/chart/tna/dailyAttendanceChart/:yyyy/:mm/:dd/:chartType',
      name: 'DailyAttendanceChart',
      component: DailyAttendanceChart,
      meta     : {
        layout: 'ChartLayout',
      },
    },

    {
      path: '/admin/chart/gew/mainChart',
      name: 'MainChart',
      component: MainChart,
      meta     : {
        layout: 'ChartLayout',
      },
    },
  ],
  // 스크롤 동작 : 브라우저가 지원하는 경우에만 작동
  // ex> https://router.vuejs.org/guide/advanced/scroll-behavior.html
  // router 호출시 scroll 위치 0,0
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to,from) => {
  sessionStorage.setItem('LAST_ROUTE_NAME', from.name)
});
